import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientEditor from "@/pages/ClientEditor";
import ShowroomManager from "@/pages/ShowroomManager";
import ClientTour from "@/pages/ClientTour";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/showrooms" element={<ShowroomManager />} />
          <Route path="/admin/clients/:clientId" element={<ClientEditor />} />
          <Route path="/t/:token" element={<ClientTour />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
